import { CognitoUserPool } from 'amazon-cognito-identity-js';
import MicruitySsoFidelity from './idps/fidelity';
import MicruitySsoVoya from './idps/voya';
import MicruitySsoVanguard from './idps/vanguard';
// import MicruitySsoService from '../../../../../lib/sso/fidelity/fe'; # TODO: this needs more thought,
// if we place it in the common folder outside either /client or /services then we need to solve its dependencies.
// One way would be to link those folders in yarn as node packages i.e. "@micruity-eapp/sso": "link: ./lib/sso/"

// TODO: solve mapping in a more flexible way (add enum field to RKs, map those instead, fetch the value here in a separate call)
const IDP_MAP = {
  Fidelity:               MicruitySsoFidelity,
  Voya:                   MicruitySsoVoya,

  // One secret per Alight API/metadata pairing. Each name must match the AWS secret referenced in the login's ACS URL.
  // Split matters on DEMO: Alight tests real logins while we can still test mock/live APIs internally.
  'Alight-ric':               MicruitySsoVoya, // external Alight API; Alight's provided metadata
  'Alight-ric-live-api':      MicruitySsoVoya, // external Alight API; sandbox-generated metadata
  'Alight-ric-mock-api':      MicruitySsoVoya, // internal mock API; sandbox-generated metadata
  'Alight-ric-mock-api-met':  MicruitySsoVoya, // internal mock API; sandbox-generated metadata
  'VG-Trlit':                 MicruitySsoVanguard,
};
const poolData = {
  UserPoolId : process.env.REACT_APP_COGNITO_POOL_ID,
  ClientId   : process.env.REACT_APP_COGNITO_WEB_CLIENT_ID,
};
const userPool = new CognitoUserPool(poolData);

const getIdpByName = function getIdpByNameFn(idpName) {
  let idp = IDP_MAP[idpName];
  if (!idp) {
    idp = MicruitySsoFidelity; // TODO: remove later. Default to Fidelity's implementation for now
  }
  return idp;
};

let inFlightGetCurrentSession = null;

const getCurrentSession = () => {
  const cognitoUser = userPool.getCurrentUser();

  if (!cognitoUser) {
    return Promise.resolve(null);
  }

  if (inFlightGetCurrentSession) return inFlightGetCurrentSession;
  inFlightGetCurrentSession = new Promise((resolve) => {
    cognitoUser.getSession((err, session) => resolve(err ? null : session));
  }).finally(() => { inFlightGetCurrentSession = null; });
  return inFlightGetCurrentSession;
};

export {
  getCurrentSession,
  getIdpByName,
};
